<template>
  <div class="orderList">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="订单列表">
          <div class="content">

            <div class="filter-box noSelect">
              <div class="filter-item">
                <div class="filter-item-left">
                  <span class="filter-item-key">订单状态</span>
                  <el-select v-model="param.status" placeholder="请选择状态" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in state_list" :key="index" :label="item" :value="index === 0 ? '' : (index-1)"></el-option>
                  </el-select>
                </div>

                <div class="filter-item-right">
                  <span class="filter-item-key">数据来源</span>
                  <el-select v-model="param.source" placeholder="数据来源" style="margin-right: 10px;">
                    <el-option :value="''" label="全部"/>
                    <el-option :value="0" label="淘宝/天猫"/>
                    <el-option :value="1" label="京东"/>
                    <el-option :value="2" label="拼多多"/>
                    <el-option :value="4" label="抖音"/>
                    <el-option :value="3" label="其他"/>
                  </el-select>
                  <el-date-picker
                      v-model="date"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </div>
              <div class="filter-item">
                <span class="filter-item-key">导出方式</span>
                <el-select v-model="param.mode" placeholder="请选择导出方式">
                  <el-option :value="''" label="全部"/>
                  <el-option :value="0" label="手动输入"/>
                  <el-option :value="1" label="模板导入"/>
                  <el-option :value="2" label="自动发货"/>
                </el-select>

                <div class="filter-item-right">
                  <el-input v-model="param.out_order_no" placeholder="输入订单号"></el-input>

                  <div class="btn btn1" @click="submitForm">查询</div>
                  <div class="btn btn2" @click="resetForm">重置</div>
                </div>
              </div>
            </div>
            <div :style="`height:60px; background-image: url('${IMG_URL}images/fzappbg.png')`">
              <a href="https://www.163.com/dy/article/FK04CABM0517C6UQ.html" class="fzapp" target="blank">
                本站已与网警协同合作，一经发现退款诈骗等行为，立即上报，点击查看案件详情！您的IP：{{ip}}，{{city}}
              </a>
            </div>

            <div class="statistics-box noSelect">
              <span class="statistics-item">今日包裹：<span class="number">0</span></span>
              <span class="statistics-item">今日消费：<span class="price">￥0</span></span>
              <span class="statistics-item">昨日包裹：<span class="number">0</span></span>
              <span class="statistics-item">昨日消费：<span class="price">￥0</span></span>
            </div>
            <el-table
                v-loading="loadingData"
                :data="tableData"
                height="600px"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                style="width: 100%">
              <el-table-column label="订单状态">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.status | statusFilter }}</span> -->
                  <el-button :type="scope.row.status === 0 ? 'danger' : scope.row.status === 1 ? 'primary' : scope.row.status === 2 ? 'success' : 'info'" size="mini">
                    <!-- {{ scope.row.status | statusFilter}} -->
                    <span v-if="scope.row.status==0">
                      <span v-if="scope.row.packnum == scope.row.error_qty">
                        已退款
                      </span>
                      <span v-else-if="scope.row.error_qty>0">
                        部分退款
                      </span>
                      <span v-else>
                        处理中
                      </span>
                    </span>
                    <span v-else>
                      {{scope.row.status | statusFilter}}
                    </span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" width="60"/>
              <el-table-column prop="out_order_no" label="订单号" width="130"/>
              <el-table-column prop="import_method" label="导入方式" width="70"/>
              <el-table-column prop="depot_name" width="100" label="仓库"/>
              <el-table-column label="数据源" width="75">
                <template slot-scope="scope">
                  <span>{{ scope.row.source === 0 ? '淘宝/天猫' : scope.row.source === 1 ? '京东' : scope.row.source === 2 ? '拼多多' : '其他' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="包裹/失败" width="55">
                <template slot-scope="scope">
                  <div>{{ scope.row.packnum }}/{{ scope.row.error_qty }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pay_total" label="总费用" width="60"/>
              <!-- <el-table-column prop="product_name" label="礼品名称" width="180"/> -->
              <el-table-column prop="createtime" label="交易时间" width="130"/>
              <el-table-column label="操作" width="220" fixed="right">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="onPackage(scope.row)">包裹</el-button>
                  <el-button type="primary" size="mini" @click="onExcel(scope.row)">导出</el-button>
                  <el-button v-if="scope.row.import_method=='自动发货'" type="primary" size="mini" @click="onDelivery(scope.row)">发货</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="page-box">
              <el-pagination
                  :page-size="param.limit"
                  :page-sizes="[20, 50, 100, 200, 300, 400]"
                  :total="total"
                  layout="prev, pager, next,total,sizes,jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"/>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="物流查询" @click="alert(1)"> </el-tab-pane> -->
        <div class="express-button" :style="`background-image: url('${IMG_URL}images/express-button0.png')`" @click="jumpExpress"></div>
        <!-- <div class="express-button" :style="`background-image: url('/static/images/express-button.png')`" @click="jumpExpress"></div> -->
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {apiOrderList,apiDelivery,apiGeo} from "@/api/api"
export default {
  name: "orderList",
  components: {headerNav, userNav, footerBox},
  data() {
    return {
      loadingData: true,
      tableData: [],
      state_list: ['全部', '任务处理中', '发货中', '已发货', '已退款'],
      date: '',
      param: {
        source: '',
        page: 1,
        limit: 20,
        mode: '',
        status: '',
        createtime: '',
        out_order_no: ''
      },
      total: 0,
      ip: '',
      city: '',
    }
  },
  filters: {
    statusFilter(value) {
      return value === 0 ? '处理中' : value === 1 ? '发货中' : value === 2 ? '已发货' : '已退款'
    }
  },
  mounted() {
    if(this.$route.query.status){
      this.param.status = Number(this.$route.query.status);
    }
    this.loadData();

    apiGeo().then(res=>{
      let data = JSON.parse(res.data)
      this.ip = data['ip'];
      this.city = data['addr'];
    })
  },
  methods: {
    jumpExpress() {
      window.open('https://52.xianfengdaifa.com/', '_blank');
    },
    onPackage(row) {
      this.$router.push({ path: '/order/packagelst', query: { out_order_no: row.out_order_no }})
    },
    onExcel(row) {
      window.open('/api/export/orderList.html?out_order_no=' + row.out_order_no)
    },
    onDelivery(row) {
      apiDelivery({"ids":row.id}).then(res => {
        console.log(res);
        if (res.code==1){
          this.$message.success("提交成功,请稍等5分钟在平台查看");
        }
      })
      // console.log(row.id)
      // window.open('/api/export/orderList.html?out_order_no=' + row.id)
    },
    timeFilter13(time) {
      let date = new Date(Number(time))
      let y = date.getFullYear()
      let m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
      let d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      let hh = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      let mm = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      let ss = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    resetForm(){
      this.param = {
        source: '',
        page: 1,
        limit: 20,
        mode: '',
        status: '',
        createtime: '',
        out_order_no: ''
      }
      this.loadData()
    },
    submitForm() {
      if (this.date) {
        var time1 = this.timeFilter13(new Date(this.date[0]).getTime())
        var time2 = this.timeFilter13(new Date(this.date[1]).getTime())
        this.param.createtime = time1 + ' - ' + time2
      }
      this.param.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.param.limit = val
      this.loadData()
    },
    // 分页
    handleCurrentChange(val) {
      this.param.page = val
      this.loadData()
    },
    loadData() {
      this.loadingData = true
      apiOrderList(this.param).then(res => {
        this.loadingData = false
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    }
  }
}
</script>


<style>
.fzapp{
  font-size: 15px;
  color: white;
  text-align: center;
  line-height: 60px;
  width:100%;
  height:100%;
  float:left;
}
.express-button{
  position: absolute;
  width: 150px;
  height: 20px;
  right: 20%;
  top: 9.5%;
  /* 鼠标小手 */
  cursor: pointer;
  /* 动画 */
  animation: myfirst 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  /* 动画结束 */
  
}
@keyframes myfirst {
  50% {
    transform: scaleX(1);
  }
  55%, 60% {
      transform: scale3d(.9,.9,.9) rotate(-3deg);
  }
  65%, 75%, 85%, 95% {
      transform: scale3d(1.1,1.1,1.1) rotate(3deg);
  }
  70%, 80%, 90% {
      transform: scale3d(1.1,1.1,1.1) rotate(-3deg);
  }
  100% {
      transform: scaleX(1);
  }
}
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #E4E4E4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.orderList {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);
      position: relative;

      .content {
        padding: 20px;

        .filter-box {
          margin-bottom: 20px;

          .filter-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            & > div {
              display: flex;
              align-items: center;
              margin-right: 20px;
            }
          }

          .filter-item-key {
            width: 70px;
            color: #000;
            font-size: 14px;
            margin-right: 10px;
          }

          .btn {
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            margin-right: 10px;
            cursor: pointer;
            flex: none;
          }

          .btn1 {
            background-color: #0f375a;
            color: #ffffff;
            margin-left: 10px;
          }

          .btn2 {
            border: 1px solid #0f375a;
            color: #0f375a;
          }

        }

        .statistics-box{
          height: 30px;
          background-color: #0f375a;
          display: flex;
          align-items: center;
          padding: 0 10px;
          .statistics-item{
            margin-right: 30px;
            color: #ffffff;

            .number{
              font-weight: bold;
            }
            .price{
              font-weight: bold;
              color: #ffffff;
            }
          }

        }

        .pages-box {
          margin-top: 20px;
        }
      }
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/lst.vue